import { faCaretLeft, faCircleLeft, faCaretRight, faPlay } from '@fortawesome/free-solid-svg-icons';
import ImageLoader from '../ImageLoader';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './HorizontalScroll.css';

const PlayerItem = ({ data, width }) => {
  // console.log(data);
  return (
    <Link
      to={data.url}
      className='capitulo relative flex flex-col items-center rounded-md bg-off-white shadow overflow-hidden cursor-pointer snap-center'
      style={{ minWidth: `${width}px` }}
    >
      <div className='relative min-w-[75%]'>
        <ImageLoader src={data.image} loadingElem={<div className='absolute inset-0 w-[500px] h-[500px] bg-gray-200 animate-pulse' />} />
        <FontAwesomeIcon icon={faPlay} className='play-icon absolute bottom-[35%] md:bottom-[45%] left-[45%] text-3xl text-red-1' />
      </div>

      <div className='flex justify-center items-center min-w-[25%] font-montserrat font-semibold text-lg'>
        <span className='mr-5'>Episodio</span>
        <span className='text-red-1'> {data?.number}</span>
      </div>
    </Link>
  );
};

const EpisodeItem = ({ data, width }) => {
  return (
    <Link
      to={`/series/${data.url}/${data.episode}`}
      className='rounded-lg overflow-hidden min-w-[100px] md:min-w-[190px] snap-center relative font-montserrat font-semibold'
    >
      <ImageLoader src={data.imagen_catalogo} alt={data.titulo} className='aspect-[4/6] min-w-[100px] md:min-w-[190px] min-h-full' />
      <div className='absolute inset-0 bg-opacity-75 bg-white rounded p-1 m-1 w-fit h-fit shadow'>Ep: {data.episode}</div>
    </Link>
  );
};

const SerieItem = ({ data, width }) => {
  return (
    <Link
      to={`/series/${data.url}`}
      className='rounded-lg overflow-hidden aspect-[4/6] max-w-[100px] md:max-w-[190px] min-w-[100px] md:min-w-[190px] snap-center relative font-montserrat font-semibold'
    >
      <ImageLoader
        src={data.imagen_catalogo}
        alt={data.titulo}
        className='aspect-[4/6] max-w-[100px] md:max-w-[190px] min-w-[100px] md:min-w-[190px]'
        style={{ minHeight: width * 1.5 }}
      />
      <div className='hidden md:block absolute inset-0 bg-opacity-75 bg-white rounded p-1 m-1 w-fit h-fit shadow'>{data.capitulos} capítulos</div>
    </Link>
  );
};

const MovieItem = ({ data }) => {};

const HorizontalScroll = ({ data, episode, serie, movie, player, index, width }) => {
  const barRef = useRef(null);
  const [barIndex, setBarIndex] = useState(Number(index) || 0);
  const placeholder = Array(10).fill(0);
  let _width = width || 100;

  if (Object.keys(data).length < 10 && Object.keys(data).length > 0) {
    // Fill cloning data
  }

  switch (true) {
    case window.matchMedia('(min-width: 768px)').matches || player:
      _width = width || 200;
      break;
  }

  const increaseBarIndex = () => {
    // Calculate current index
    const scrollValue = barRef.current.scrollLeft;
    const index = Math.round(scrollValue / _width);

    // Increase index
    setBarIndex(index + 1);
  };

  const decreaseBarIndex = () => {
    // Calculate current index
    const scrollValue = barRef.current.scrollLeft;
    const index = Math.round(scrollValue / _width);

    // Increase index
    setBarIndex(index - 1);
  };

  useEffect(() => {
    if (barIndex < 0) {
      setBarIndex(data?.length - 1 - barIndex);
      return;
    } else if (barIndex > data?.length - 1 && data?.length) {
      setBarIndex(0);
      return;
    }

    if (barRef.current) {
      try {
        const scrollValue = _width * barIndex;
        barRef.current.scrollTo({
          left: scrollValue,
          behavior: 'smooth',
        });
      } catch (err) {
        // console.log(err);
      }
    }
  }, [barIndex]);

  return (
    <>
      <div className='flex items-center'>
        <button onClick={decreaseBarIndex} className='transition-all text-red-1 hover:text-red-2 hover:scale-105'>
          <FontAwesomeIcon icon={faCaretLeft} className='text-[2rem] md:text-[4rem]' />
        </button>
      </div>
      <div ref={barRef} className='bar flex gap-[10px] max-w-full overflow-x-scroll snap-x my-auto'>
        {data?.length
          ? data?.map((item, index) => {
              switch (true) {
                case episode:
                  return <EpisodeItem data={item} key={index} width={_width} />;
                case serie:
                  return <SerieItem data={item} key={index} width={_width} />;
                case movie:
                  return <MovieItem data={item} key={index} width={_width} />;
                case player:
                  return <PlayerItem data={item} key={index} width={_width} />;
              }
            })
          : placeholder.map((item, index) => {
              return player ? (
                <div key={index} className='min-w-[200px] aspect-video bg-gray-200 animate-pulse m-0'>
                  <div className='absolute inset-0 bg-opacity-75 bg-white rounded p-1 m-1 shadow w-10 h-6' />
                </div>
              ) : (
                <div
                  key={index}
                  className='rounded-lg overflow-hidden min-w-[100px] md:min-w-[190px] snap-center relative border animate-pulse bg-slate-200'
                  style={{ height: (_width - 10) * 1.5 }}
                >
                  <div className='absolute inset-0 bg-opacity-75 bg-white rounded p-1 m-1 shadow w-10 h-6' />
                </div>
              );
            })}
      </div>
      <div className='flex items-center ml-auto mr-0'>
        <button onClick={increaseBarIndex} className='transition-all text-red-1 hover:text-red-2 hover:scale-105'>
          <FontAwesomeIcon icon={faCaretRight} className='text-[2rem] md:text-[4rem]' />
        </button>
      </div>
    </>
  );
};

export default HorizontalScroll;
